module.exports = __webpack_public_path__ + "static/media/linked_list_with_addresses.79be9abd.png";